import React  from 'react';
import { TextField } from '@mui/material'
import { useRecoilValue } from 'recoil';
import useSavePatient from 'src/Patient/hooks/useSavePatient'
import { errorsFormRegisterState, valuesFormRegisterState } from 'src/Patient/state/atoms';
import InputLabelCustom from 'src/shared/components/forms/InputLabelCustom'

const EmailField = ({ onKeyEnter }) => {
    const { handleChange } = useSavePatient();
    const { uswEmail } = useRecoilValue(valuesFormRegisterState);
    const { uswEmail: errorUswEmail } = useRecoilValue(errorsFormRegisterState);

    let propsEmailField = {};
    if (onKeyEnter) {
        propsEmailField['onKeyPress'] = (ev) => {
            if (ev.key === "Enter") {
                onKeyEnter();
            }
        }
    }

    return (
        <>
            <InputLabelCustom htmlFor="input-email" text="Correo electrónico (*)" />
            <TextField
                id="input-email"
                size="small"
                error={errorUswEmail && errorUswEmail.length > 0 ? true : false}
                helperText={errorUswEmail && errorUswEmail.length > 0 ? `${errorUswEmail.join("\n")}` : ''}
                style={{ width: '100%' }}
                name="uswEmail"
                type="text"
                value={uswEmail || ""}
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                onChange={handleChange}
                autoComplete="off"
                placeholder='Ej: correo@dominio.cl'
                {...propsEmailField}
            />
        </>
    )
}

export default EmailField
